<template>
<div>
  <v-parallax
    dark
    src="/sumo/images/parallax/plax2.jpg"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        class='hidden-sm-and-down'
        :lg='3'
        :md='4'
      >
      <img
        class="guide-image align-end"
        lazy-src="/sumo/images/loginscreen.png"
        max-height="768"
        max-width="300"
        src="/sumo/images/newgifs/therolist.gif"
      >
      </v-col>
      <v-col
        class="text-start"
        :lg='5'
        :md='6'
        :sm='10'
        border
      >
        <h3 class="display-1 font-weight-medium mb-2">
          Summit Mobile: SuMo
        </h3>

        <blockquote>
            Summit Mobile: SuMo is a mobile application for Android and iOS devices to be used with the SummitCRS Management System. Utilize built in time clock and production tools to gather more accurate and timely information about your production process.
        </blockquote>
          <div class='mt-2'>
            <v-btn class='success' href='#contact'>Get Started</v-btn>
          </div>
      </v-col>
    </v-row>
  </v-parallax>

  <v-layout row wrap justify-center ma-5 text-center>
    <v-flex xs12 sm10 md3 ma-1 :key="index" v-for="(channel, index) in channels">
      <v-layout row wrap align-center justify-center ma-2>
        <v-flex xs12 text-xs-center>
          <v-icon size="100" color='blue-grey darken-2'>{{ channel.icon }}</v-icon>

        </v-flex>
        <v-flex xs10 sm12>
          <P class="headline">{{ channel.headline}}</p>
        </v-flex>
        <v-flex xs10 sm10>
          {{ channel.desc }}
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

  <!-- Start Android iOS Parallax -->
    <v-parallax
      dark
      src="/sumo/images/parallax/plax4.jpg"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          class="text-center"
          cols="12"
        >
          <v-layout ma-5 row wrap justify-center align-center pa-5>
            <v-flex sm10 md6 lg6 pa-5 order-xs2>
              <p align='center'>
               <a href="https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1235153348&mt=8">
                 <img src="images/app-store-badge.svg" width="200px" height="auto"/>
               </a>
               <a href="https://play.google.com/store/apps/details?id=com.embarcadero.SuMo">
                 <img src="images/android.png" width="auto" height="60">
               </a>
             </p>
              <h3 class='display-1 font-weight-medium mb-2'>Android and iOS Mobile Support</h3>
              <blockquote>
                With SuMo you are no longer tied to a desk, keep production moving where ever you or your staff are.
                SuMo is ready to be installed directly to your mobile device with Android or iOS.
              </blockquote>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
    </v-parallax>
  <!-- End Android iOS Parallax -->

  <v-layout ma-5 pa-5 row wrap justify-center align-center>
        <v-flex sm8 md4 xl4 pa-5>
          <v-img
            class='elevation-20'
            src="/sumo/images/movero.jpg"
            max-height="635"
            max-width="600"
            />
        </v-flex>
        <v-flex md6 xl4 pa-5>
          <h1 class='mb-2'>Improved Cycle Time</h1>
          <h3 class='font-weight-light'>
            Users have the ability to move a repair order to the next department in production capturing exact cycle times
            for each department and triggering automatic labor flags for efficiency calculations. Actions will update SummitCRS, Terminal and Scoreboard the moment they are submitted
          </h3>
        </v-flex>
      </v-layout>
      <v-divider class='hidden-md-and-up'></v-divider>
      <v-layout ma-5 row wrap justify-center align-center pa-5>
        <v-flex md6 xl4 pa-5 order-xs2 order-md1>
          <h1 class='mb-2'>Hourly and Flat Rate Job Costing</h1>
          <h3 class='font-weight-light'>
            SuMo takes the time clock of TechCentral and puts it in the hands of your technician. Users can conveniently create hourly clock punches or
            trigger automatic labor flags ensuring up to date and accurate job costing.
          </h3>
        </v-flex>
        <v-flex sm8 md4 xl4 pa-5 order-sm1>
          <v-img
            class='elevation-20'
            src="/sumo/images/jobcosting.jpg"
            max-height="556"
            max-width="268"
            />
        </v-flex>
      </v-layout>
      <v-divider class='hidden-md-and-up'></v-divider>
      <v-layout ma-5 row wrap justify-center align-center pa-5>
        <v-flex sm8 md4 xl4 pa-5>
          <v-img
            class='elevation-20'
            src="/sumo/images/createro.jpg"
            max-height="556"
            max-width="268"
            />
        </v-flex>
        <v-flex md6 xl4 pa-5>
          <h1 class='mb-2'>Create Repair Orders</h1>
          <h3 class='font-weight-light'>
            With SuMo you are no longer tied to a desk, create a repair order in the palm of your hand and capture and upload images directly to SummitCRS.
            Later linking in your estimate from Audatex, CCC & Mitchell estimating systems.
          </h3>
        </v-flex>
      </v-layout>

      <v-divider class='hidden-md-and-up'></v-divider>
      <v-layout ma-5 row wrap justify-center align-center pa-5>
        <v-flex md6 xl4 pa-5 order-xs2 order-md1>
          <h1 class='mb-2'>Technician Status</h1>
          <h3 class='font-weight-light'>
            The tech status screen allows you to see the repair order that each technician is currently clocked into and administer current punches.
            Each tech status shows how long they have been working on the job as well as total hours and current production department.
          </h3>
        </v-flex>
        <v-flex sm8 md4 xl4 pa-5 order-sm1>
          <v-img
            class='elevation-20'
            src="/sumo/images/techstatus.jpg"
            max-height="556"
            max-width="268"
            />
        </v-flex>
      </v-layout>

      <v-layout ma-5 pa-5 row wrap justify-center align-center>
            <v-flex sm8 md4 xl4 pa-5>
              <v-img
                class='elevation-20'
                src="/sumo/images/deptchecklist.jpg"
                max-height="635"
                max-width="600"
                />
            </v-flex>
            <v-flex md6 xl4 pa-5>
              <h1 class='mb-2'>QC Checklists</h1>
              <h3 class='font-weight-light'>
                Utilizing SummitCRS' department checklists create quality control check lists for each production department that requires user
                aknowlegement capturing date and user.
              </h3>
            </v-flex>
          </v-layout>
          <v-divider class='hidden-md-and-up'></v-divider>
          <v-layout ma-5 row wrap justify-center align-center pa-5>
            <v-flex md6 xl4 pa-5 order-xs2 order-md1>
              <h1 class='mb-2'>Review Job Lines</h1>
              <h3 class='font-weight-light'>
                View all joblines on your mobile device communicating repair critical data including labor operation, hours, part type and part
                numbers. You can utilize labor filters to narrow your focus to specific labor type lines.
              </h3>
            </v-flex>
            <v-flex sm8 md4 xl4 pa-5 order-sm1 text-center>
              <v-img
                class='elevation-20'
                src="/sumo/images/joblines.jpg"
                max-height="635"
                max-width="476"
              />
            </v-flex>
          </v-layout>
          <v-divider class='hidden-md-and-up'></v-divider>
          <v-layout ma-5 row wrap justify-center align-center pa-5>
            <v-flex sm8 md4 xl4 pa-5 text-center>
              <v-img
                class='elevation-20'
                src="/sumo/images/partstatus.jpg"
                max-height="635"
                max-width="476"
              />
            </v-flex>
            <v-flex md6 xl4 pa-5>
              <h1 class='mb-2'>Part Status</h1>
              <h3 class='font-weight-light'>
                Part Status is displayed in the joblines to easily communicate to you if the part has been recieved or on order. Parts Only filtering displays all part lines and status' in the job lines.
              </h3>
            </v-flex>
          </v-layout>
</div>
</template>

<script>
  export default {
    data() {
      return{
        channels: [
          {
            headline: 'Update Production Status',
            desc: 'Move repair orders to the next department capturing live cycle times and keeping your production inventory up to date.',
            icon: 'mdi-timer-outline'
          },
          {
            headline: 'Hourly and Flat Rate Job Costing',
            desc: 'Automatically creates Job Costs for Hourly and Flat Rate employees when clocking into repair orders and updating repair status.',
            icon: 'mdi-bullseye-arrow '
          },
          {
            headline: 'Image Capture',
            desc: 'Utilize your Android or iOS built-in Camera for image capture and upload to SummitCRS: Mediapoint.',
            icon: 'mdi-camera-outline'
          },
          {
            headline: 'Technician Status',
            desc: 'Management can see all techs on one screen providing what job they are currently clocked into as well as how long.',
            icon: 'mdi-eye-outline'
          },
          {
            headline: 'Department Checklists',
            desc: 'Checklist items require acknowledgement of completion before repair orders can be moved to next department.',
            icon: 'mdi-format-list-checks'
          },
          {
            headline: 'Review Job Lines',
            desc: 'View repair order job lines. Including: hours, labor operation, and labor type to reduce printed job worksheets.',
            icon: 'mdi-format-list-numbered'
          },
          {
            headline: 'View Part Status',
            desc: 'List all parts on a repair order, including part number and status if ordered or received.',
            icon: 'mdi-truck-check-outline'
          },
          {
            headline: 'Create Repair Orders',
            desc: 'Create a blank repair order with basic RO admin information to upload images and sync an estimate to.',
            icon: 'mdi-file-plus-outline'
          },
          {
            headline: 'Job Hour Totals',
            desc: 'Review hours by line or job total with filtering options for each labor type.',
            icon: 'mdi-calculator-variant'
          },
        ],
      }
    }
  }
  </script>
